/**
 * @file Basic Controller
 */

'use strict'
import Listener from '../Utils/Listener'
import BasicModel from '../Model/BasicModel'
import Common from '../Utils/Common'

let instance = null

/**
 * @classname Basic
 * @classdesc Basic Controller
 */
export default class Basic {
	/**
	 * @constructor
	 */
	constructor() {
		if (instance) {
			return instance
		}
		console.log('Basic.constructor')

		this._model = new BasicModel()

		this._listener = new Listener()

		this._model.on('incrementReactionCountComplete', () => {
			this._incrementReactionCountResponse = this._model._data
			this._listener.trigger('incrementReactionCountComplete')
		})
		this._model.on('favoriteComplete', () => {
			this._listener.trigger('favoriteComplete');
		})
		this._model.on('favoriteError', () => {
			this._listener.trigger('favoriteError');
		})
		this._model.on('saveFilteringComplete', () => {
			this._listener.trigger('saveFilteringComplete');
		})
		this._model.on('deleteFilteringComplete', () => {
			this._listener.trigger('deleteFilteringComplete');
		})
		this._model.on('deleteDocumentComplete', () => {
			this._listener.trigger('deleteDocumentComplete');
		})
		this._model.on('constHitNumComplete', () => {
			this._hitData = this._model._data
			this._listener.trigger('constHitNumComplete');
		})

		instance = this
		return instance
	}

	/**
	 * お気に入り
	 *
	 * @memberof Basic
	 * @param {string} jobId - 求人
	 * @return {undefined}
	 */
	favorite(jobId) {
		console.log('Basic.favorite');
		this._model.favorite(jobId);
	};

	/**
	 * 「読んだよ！」ボタンのカウントを増やす
	 *
	 * @memberof Basic
	 * @param {integer} articleId - 記事ID
	 * @return {undefined}
	 */
	incrementReactionCount(articleId) {
		console.log('Basic.incrementReactionCount')
		this._model.incrementReactionCount(articleId)
	}

	/**
	 * 表示中の検索条件を保存
	 *
	 * @memberof Basic
	 * @return {undefined}
	 */
	saveFiltering(params) {
		console.log('Basic.saveFiltering');
		this._model.saveFiltering(params);
	}

	/**
	 * 保存した検索条件を削除
	 *
	 * @memberof Basic
	 * @return {undefined}
	 */
	 deleteFiltering(filteringId, name) {
		console.log('Basic.deleteFiltering');
		this._processingFilteringId = filteringId;
		this._model.deleteFiltering(filteringId, name);
	}

	/**
	 * 書類の削除
	 *
	 * @memberof Basic
	 * @return {undefined}
	 */
	deleteDocument(documentId, name) {
		console.log('Basic.deleteDocument');
		this._processingDocumentId = documentId;
		this._model.deleteDocument(documentId, name);
	}

	/**
	 * 該当する求人数の取得
	 *
	 * @memberof Basic
	 * @return {undefined}
	 */
	 countHitNum(params) {
		console.log('Basic.getCountHitNum');
		this._model.countHitNum(params);
	}

	/**
	 * listener on
	 *
	 * @memberof Basic
	 * @param {string} name - イベント名
	 * @param {function} fn - 実行する関数
	 * @return {undefined}
	 */
	on(name, fn) {
		this._listener.on(name, fn)
	}

	/**
	 * listener off
	 *
	 * @memberof Basic
	 * @param {string} name - イベント名
	 * @param {function} fn - 実行する関数
	 * @return {undefined}
	 */
	off(name, fn) {
		this._listener.off(name, fn)
	}
}
